import React from 'react'
import useModal from './modalHook';
import AddDiscount from '../views/shared/settings/discount/AddDiscount';
import { useQueryClient } from '@tanstack/react-query';

const useDiscount = () => {
    const { ModalComponent, updateModalStates, closeModal } = useModal();
    const queryClient = useQueryClient()
    const DiscountModal = ModalComponent;

      const showAddDiscount = () => {
        updateModalStates({
          show: true,
          size: 'xl',
          children: (
            <AddDiscount
              onProceed={() => {
                closeModal();
                queryClient.invalidateQueries({queryKey:['getDiscounts']})
              }}
              onClose={closeModal}
            />
          ),
          title: 'Add New Discount',
          classes: '!p-0 r-[5px]'
        });
      };
  return {
    showAddDiscount,
    DiscountModal
  }
}

export default useDiscount